var $e59b93b4e4946a8d$exports = {};
$e59b93b4e4946a8d$exports = {
    "collectionLabel": `Sugestie`
};


export {$e59b93b4e4946a8d$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
